export default __webpack_public_path__ + "static/media/1.069da961.webp";